import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group relative h-full',
    item: 'md:hover:bg-bg-items-white flex h-full min-w-80 cursor-pointer flex-col duration-150 ease-initial max-md:min-w-75',
    articleLink: 'absolute inset-0 z-10 opacity-0',
    imageWrap: 'relative',
    image: 'aspect-40/29 min-w-full object-cover md:aspect-11/8',
    subtitleWrap: 'absolute inset-x-3 bottom-0',
    tagContainer: 'absolute inset-x-3 bottom-0 translate-y-1/2',
    labelContainer:
      'absolute inset-x-3 bottom-0 z-10 flex translate-y-1/2 flex-wrap gap-1',
    label:
      'data-[with-hover=true]:hover:text-main data-[with-hover=true]:hover:bg-bg-items-white px-3 tracking-[6%] uppercase transition-colors',
    tag: 'px-3 tracking-[6%] text-white',
    body: 'px-4 py-7',
    title: 'mb-2 text-xl font-bold',
    subtitle:
      'bg-icon-star inline-block translate-y-1/2 rounded-[100px] pt-0.5 pr-3 pb-0.5 pl-3 text-sm uppercase',
    description: 'heading-m line-clamp-4 w-full',
    link: 'mt-0 inline-flex items-center text-xs font-semibold uppercase lg:mt-3',
    linkIcon: 'flex-center h-12 w-12',
    metaList: 'absolute top-4 right-4 flex items-center gap-2',
    metaItem:
      'heading-xs flex h-6 items-center gap-1 overflow-hidden rounded-full bg-white/60 px-2 backdrop-blur-[20px]',
    metaItemIcon: 'text-blue size-4',
    avatarWrap:
      'absolute bottom-6 left-4 flex items-center gap-4 rounded-full bg-transparent py-0.5 pr-5 pl-0.5 transition-all',
    avatarImageWrap:
      'relative size-16 overflow-hidden rounded-full border-2 border-white/50 backdrop-blur-[22px] max-md:size-12',
    avatarImageWrapContainer: 'flex',
    avatarImage: 'object-cover',
    withDoctor:
      'heading-s-bold group-hover:text-main max-md:heading-xs-bold max-lg:text-main w-[160px] text-transparent transition-colors max-md:w-[140px]',
    videoPlay:
      'absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-5',
    videoIconWrap:
      'relative size-20 rounded-full backdrop-blur-[30px] backdrop-opacity-0 transition-all group-hover:bg-white/20 group-hover:backdrop-opacity-100',
    videoIcon:
      'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover:opacity-100',
    videoText:
      'heading-s-bold text-transparent uppercase transition-colors group-hover:text-white',
    advertisingInformer: 'absolute z-10',
    advertisingInformerContent: ''
  },
  variants: {
    withDoctor: {
      true: {
        avatarWrap:
          'backdrop-blur-[30px] backdrop-opacity-0 group-hover:bg-white/50 group-hover:backdrop-opacity-100 max-lg:bg-white/50'
      }
    },
    doctorAvatar: {
      true: {
        avatarImageWrap: '-ml-6 max-md:-ml-4'
      }
    },
    hasDate: {
      true: {
        advertisingInformer: 'right-4 bottom-4',
        advertisingInformerContent: 'max-lg:-top-[46px]'
      },
      false: {
        advertisingInformer: 'top-3 right-3'
      }
    }
  },
  defaultVariants: {
    hasDate: false
  }
});
